import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import Store from '@app/store';

import SignInForm from '@component/form/signin';
import StaticPage from '@component/panel/content';

import ClickTracker from '@helper/click-tracker';

export const callback = (instance) => {
  const trackers = new ClickTracker({
    page: 'plus',
    body: instance,
    track: [
      {
        selector: '.button--sign-up',
        action: 'click_sign_me_up',
        label: 'half_panel',
      },
      {
        selector: '.button--read-more',
        action: 'click_more_about_plus',
        label: 'half_panel',
      },
      {
        selector: '#sign-in-free-account-free-button',
        action: 'click_create_an_account',
        label: 'half_panel',
      },
      {
        selector: '#sign-in-free-account-plus-button',
        action: 'click_get_wetransfer_plus',
        label: 'half_panel',
      },
    ],
  });

  // We want to be updated with store updates
  instance.subscribeToStore = true;
  // Get our DOM elements
  const formContainer = instance.node.querySelector('.signin__form-container');
  const signUpBtn = instance.node.querySelector('.button--sign-up');
  const readMoreBtn = instance.node.querySelector('.button--read-more');

  // Replace trk param on CTA when the app auto routes user to sign-in page on 3rd visit
  const { route } = Store.getState();

  if (route.query.trk) {
    const getHref = (path) =>
      new URL(`${path}?trk=${route.query.trk}`, location.origin);
    if (signUpBtn) {
      signUpBtn.href = getHref('/sign-up');
    }
    if (readMoreBtn) {
      readMoreBtn.href = getHref('/pro');
    }
  }

  ReactDOM.render(
    <Provider store={Store}>
      <SignInForm />
    </Provider>,
    formContainer
  );
  trackers.attach();

  // When we navigate away from the page, cleanup listeners
  instance.onCleanup = () => {
    ReactDOM.unmountComponentAtNode(formContainer);
    trackers.remove();
  };
};

StaticPage.configure('/log-in', callback);
